/**
 * @generated SignedSource<<7ce8b8d7f2e144cfed194d061a30ef8c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BeliefSystemSelectInput_query$data = {
  readonly beliefSystems: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
      readonly rowId: any;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "BeliefSystemSelectInput_query";
};
export type BeliefSystemSelectInput_query$key = {
  readonly " $data"?: BeliefSystemSelectInput_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BeliefSystemSelectInput_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BeliefSystemSelectInput_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SEQUENCE_ASC"
          ]
        }
      ],
      "concreteType": "BeliefSystemConnection",
      "kind": "LinkedField",
      "name": "beliefSystems",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BeliefSystem",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "beliefSystems(orderBy:[\"SEQUENCE_ASC\"])"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "da56d6051daaef49332266f8a8773b05";

export default node;
